import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { Env, readFromEnv } from "@cinch-nx/environments";
import { traceFunction, tagError, setTag } from "@core/datadog-server";
import { getStoryBySlug } from "@cinch-nx/data-storyblok";
import { capitaliseFirstLetter } from "./utils/capitalise-first-letter";
export var VEHICLE_SEARCH_URL = "".concat(readFromEnv(Env.SearchServiceUrl), "/vehicles");
var formatHeroAddress = function(address) {
    return "".concat(address.addressLine1, ", ").concat(address.addressLine2, ", ").concat(address.townOrCity, ", ").concat(address.postCode);
};
export var getStaticPropsfn = function() {
    var _ref = _async_to_generator(function(param) {
        var params, _preview, preview, storeName, story, storeVehicles, response, vehicleListings, error, heroProps, error1;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = param.params, _preview = param.preview, preview = _preview === void 0 ? false : _preview;
                    storeName = params === null || params === void 0 ? void 0 : params.slug;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        getStoryBySlug("store/".concat(storeName), {
                            version: preview ? "draft" : "published"
                        })
                    ];
                case 2:
                    story = _state.sent();
                    if (!story) {
                        throw new Error("Store information story not found");
                    }
                    storeVehicles = [];
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        fetch("".concat(readFromEnv(Env.SearchServiceUrl), "/vehicles?store=").concat(storeName))
                    ];
                case 4:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new Error("Failed to fetch vehicles: ".concat(response.statusText));
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 5:
                    vehicleListings = _state.sent().vehicleListings;
                    storeVehicles = vehicleListings.length < 9 ? vehicleListings : vehicleListings.slice(0, 9);
                    return [
                        3,
                        7
                    ];
                case 6:
                    error = _state.sent();
                    if (_instanceof(error, Error) || typeof error === "string") {
                        tagError(error);
                    }
                    storeVehicles = [];
                    return [
                        3,
                        7
                    ];
                case 7:
                    setTag("response.code", 200);
                    setTag("page.rendered", "ISR");
                    setTag("page.revalidate-in", "60s");
                    setTag("page.name", "store/".concat(storeName));
                    setTag("page.params", JSON.stringify({
                        preview: preview,
                        storeVehicles: storeVehicles
                    }, null, 2));
                    setTag("page.response-code", "200");
                    heroProps = _object_spread_props(_object_spread({}, story.content.storeHero[0]), {
                        title: "cinch Store ".concat(capitaliseFirstLetter(storeName)),
                        address: formatHeroAddress(story.content.address[0]),
                        telephoneNumber: story.content.phoneNumbers[0].phoneNumber
                    });
                    return [
                        2,
                        {
                            props: {
                                story: story,
                                preview: preview,
                                generatedAt: Date.now(),
                                layoutProps: {
                                    showBorderRadius: true,
                                    heroProps: heroProps
                                },
                                storeVehicles: storeVehicles
                            },
                            revalidate: 60
                        }
                    ];
                case 8:
                    error1 = _state.sent();
                    if (typeof error1 === "string" || _instanceof(error1, Error)) {
                        console.log(error1);
                    }
                    return [
                        2,
                        {
                            notFound: true
                        }
                    ];
                case 9:
                    return [
                        2
                    ];
            }
        });
    });
    return function getStaticPropsfn(_) {
        return _ref.apply(this, arguments);
    };
}();
export var getStaticProps = traceFunction("store-page.getStaticProps", getStaticPropsfn);
